import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type EnsRecord = ObjectId & {
  name?: string;
};

type EnsRecordNotFoundErrorOptions = {
  ensRecord: EnsRecord;
  site?: ObjectId;
};

export class EnsRecordNotFoundError extends FleekError<EnsRecordNotFoundErrorOptions> {
  public name = 'EnsRecordNotFoundError';

  toString = () => {
    if (this.data.site?.id) {
      return `No site associated with this ENS record.`;
    }

    return `ENS record was not found.`;
  };
}
